import React, { useMemo } from 'react';

import { DiscountTagRow } from './DiscountTags';

import { createAction } from 'utils';
import { enLocaleDollarFormatter } from 'utils/NumberUtils';

import './ProductItem.scss';
import i18n from 'I18n';

const ProductItem = ({ extraStyle, data }) => {
  return (
    <div className={`productContainer ${extraStyle}`}>
      <div className={'product'}>
        <span className={'productText body-1'}>{data.name}</span>
      </div>
      <div className='product-price-with-quantity'>
        <span className='productText body-1'>{enLocaleDollarFormatter(data.singleOriginalPrice)}</span>
        <span className='productText body-1 margin-left-8'>{`x${data.quantity}`}</span>
      </div>
      {data?.discounts?.length > 0 && (
        <DiscountTagRow extraStyle={'discount'} discounts={data?.discounts} />
      )}

      <div className={'price'}>
        {data.showOriginalPrice && (
          <span className={'priceText priceDelete body-1'}>
            {enLocaleDollarFormatter(data.originalPrice)}
          </span>
        )}
        <span className={'priceText body-2'}>
          {enLocaleDollarFormatter(data.value)}
        </span>
      </div>

      {
        data.isRefund && (
          <div className='product'>
            <div className='refund-quantity'>
              <span className='priceText refundColor body-2'>
                {i18n.t('records:transaction_refunded')}
              </span>
              <span className='priceText refundColor body-2 margin-left-8'>
                {`x${data.refundedQuantity}`}
              </span>
            </div>
            <span className='priceText refundColor body-2'>
              {"-"}{enLocaleDollarFormatter(data.totalRefundValue)}
            </span>
          </div>
        )
      }
    </div>
  );
};

export default ProductItem;
